<template>
<div style="padding: 20px">
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="门禁编号" prop="devicesn">
      <el-input v-model="addEditForm.devicesn" placeholder="请输入门禁编号"></el-input>
    </el-form-item>
    <el-form-item label="门禁名称" prop="name">
      <el-input v-model="addEditForm.name" placeholder="请输入门禁名称"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>
<script>
import {facedeviceadd, facedeviceupdate} from '../../../api/yanglaoyuan'

export default {
  name: 'facePerson',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    faceObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        devicesn: '',
        name: '',
        orgid: ''
      },
      addEditRules: {
        devicesn: [
          {required: true, message: '请输入门禁编号', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入门禁名称', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.addEditForm.orgid = this.$store.state.user.orgid
    if (!this.faceObj.isAdd) {
      this.addEditForm.devicesn = this.faceObj.row.devicesn
      this.addEditForm.name = this.faceObj.row.name
      this.addEditForm.orgid = this.faceObj.row.orgid
    }
  },
  mounted () {
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            devicesn: this.addEditForm.devicesn,
            name: this.addEditForm.name,
            orgid: this.addEditForm.orgid
          }
          if (!this.faceObj.isAdd) {
            data.id = this.faceObj.row.id
            facedeviceupdate(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑门禁', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            facedeviceadd(data).then(res => {
              this.$notify({title: '成功', message: '成功新增门禁', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditFaceDevice.vue